export const getYoutubeVideoCover = (code: string) => `https://i.ytimg.com/vi/${code}/maxresdefault.jpg`;
